import { controversyItems } from '@/mocks/gossipContent';
import Reveal from '@/components/base/Reveal';

export default function ControversySection() {
  return (
    <section id="debate" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
            <div>
              <div className="flex items-center gap-2 text-xs">
                <span className="font-heading text-accent-700 tracking-widest">CH.05</span>
                <span className="h-px w-8 bg-background-300" />
                <span className="text-foreground-500">争议事件 · 多面复盘</span>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold mt-3 tracking-tight">
                争议之下，<span className="text-accent-700">不止一面</span>
              </h2>
            </div>
            <p className="max-w-md text-sm text-foreground-600 leading-relaxed">
              每场争议都摆出各方立场与讨论风向，不站队、不预判，把矛盾点摊开给你看。
            </p>
          </div>
        </Reveal>

        <div className="mt-7 space-y-4">
          {controversyItems.map((it, idx) => (
            <Reveal key={it.id} delay={(idx % 3) * 50}>
              <article className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 hover:border-accent-300 transition-colors">
                <div className="md:col-span-1 flex md:flex-col items-center gap-3">
                  <span className="font-heading text-4xl md:text-5xl font-black leading-none text-background-200 group-hover:text-accent-400 transition-colors">
                    {it.number}
                  </span>
                </div>
                <div className="md:col-span-6">
                  <h3 className="font-heading text-lg md:text-xl font-bold leading-snug group-hover:text-accent-800 transition-colors">
                    {it.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-foreground-700 leading-relaxed">{it.focus}</p>
                  <div className="mt-3 inline-flex items-center gap-1.5 text-xs text-accent-700">
                    <i className="ri-line-chart-line w-4 h-4 flex items-center justify-center" />
                    {it.trend}
                  </div>
                </div>
                <div className="md:col-span-5 flex flex-col gap-2">
                  <div className="text-xs text-foreground-500 mb-1">各方声音</div>
                  {it.views.map((v) => (
                    <div
                      key={v}
                      className="flex items-center gap-2 rounded-md bg-background-100 px-3 py-2 text-xs text-foreground-700"
                    >
                      <i className="ri-chat-quote-line text-accent-500 w-4 h-4 flex items-center justify-center shrink-0" />
                      {v}
                    </div>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}